import { Box, Button, Typography } from "@mui/material";
import MemoryWall from "../../components/MemoryWall";
import { Link } from "react-router-dom";

export const Gallerij = () => {
  return (
    <Box sx={{ textAlign: "center", mt: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Lees en zie hier herinneringen van anderen
      </Typography>

      <Button
        component={Link}
        to="/herinnering"
        variant="contained"
        sx={{
          backgroundColor: "#3c5875",
          color: "white",
          textTransform: "none",
          fontWeight: 500,
          px: 3,
          py: 1.2,
          borderRadius: "30px",
          mb: 3,
          "&:hover": { backgroundColor: "#2c455a" },
        }}
      >
        💬 Voeg een herinnering hieraan toe
      </Button>

      <MemoryWall />
    </Box>
  );
};
